const toPx = val => `${val}px`;

export default toPx;
